import { render, staticRenderFns } from "./NewOTIndex.vue?vue&type=template&id=186ed97c&scoped=true&lang=pug"
import script from "./NewOTIndex.vue?vue&type=script&lang=js"
export * from "./NewOTIndex.vue?vue&type=script&lang=js"
import style0 from "./NewOTIndex.vue?vue&type=style&index=0&id=186ed97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ed97c",
  null
  
)

export default component.exports